import React, { useState, useEffect, useCallback } from 'react';
import "../styles/steps.css";

const ProjectNameDate = ({ formData, updateFormData, setStepValidation, stepNumber }) => {
    const [error, setError] = useState('');

    // Validate fields when Next is clicked
    const validateFields = useCallback((nextClicked = false) => {
        let errorMessage = '';
        if (nextClicked) {
            if (!formData.projectName || formData.projectName.trim().length < 3) {
                errorMessage = 'Project Name must be at least 3 characters.';
            } else if (!formData.startDate) {
                errorMessage = 'Project Start Date is required.';
            }
        }
        setError(errorMessage);
        return errorMessage === ''; // Returns true if valid, false if not
    }, [formData.projectName, formData.startDate]);

    // Expose the validation function to ProjectWizard
    useEffect(() => {
        if (setStepValidation) {
            setStepValidation(stepNumber, validateFields);
        }
    }, [setStepValidation, stepNumber, validateFields]);

    // Handle input changes and clear error on valid input
    const handleChange = (e) => {
        const { name, value } = e.target;
        updateFormData({ [name]: value });

        // Clear error when user types
        if (error) {
            validateFields();
        }
    };

    return (
        <div className="step-container">
            <p className="step-description">
            This wizard helps you estimate your project's time, cost, and resource requirements. Start by entering your project name and start date to establish a clear timeline. You can save progress anytime and revisit any step to refine details as needed.            
            </p>
            <br></br>
            <div className="input-group-inOneRow">
                <label className="input-label">Project Name:</label>
                <input
                    className="input-number-field"
                    type="text"
                    name="projectName"
                    placeholder="Project Name"
                    value={formData.projectName}
                    onChange={handleChange}
                    required
                />
                <label className="input-label">Project Start Date:</label>
                <input
                    className="input-number-field"
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleChange}
                    required
                />
            </div>

            {/* Show error message inside the step if validation fails */}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default ProjectNameDate;